import customerService from "@/services/customer";

// Phone lookup can find a salon customer who is not assigned to the caller.
// Only the caller's customer list establishes membership.
export async function isMyCustomer(customerId: number, phoneNumber: string) {
  const pageSize = 50;
  for (let skip = 0; ; skip += pageSize) {
    const page = await customerService.getCustomers({ Term: phoneNumber, Skip: skip, Count: pageSize });
    if (!Array.isArray(page.result)) throw new Error("فهرست مشتریان دریافت نشد");
    if (page.result.some(customer => customer.id === customerId)) return true;
    if (page.result.length < pageSize) return false;
  }
}
